import React from 'react';
import SpielErgebnis from '../SpielErgebnis/SpielErgebnis';
import EventSubscription from '../EventSubscription/EventSubscription';
import { FormattedEvent } from '../../../types';
import { formatDateForEventItem } from '../../../functions/date';
import { FiClock, FiMapPin } from 'react-icons/fi';
import { FaHome, FaCarSide } from 'react-icons/fa';
import './EventItem.css'
import { EventDescription } from '../EventDescription/EventDescription';

interface EventItemProps {
  event: FormattedEvent;
}

function getGoogleMapsLink(location: string): string {
  const encodedLocation = encodeURIComponent(location);
  return `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;
}


const EventItem: React.FC<EventItemProps> = ({ event }) => {
  console.log("Render EventItem:", event);
  return (
    <div className={`event-item ${event.team?.Altersklasse?.toLowerCase() || '' }`}>

      {event.category !== "other" ?
        <div className="liga-info">
          <a href={event.liga.URL} className="liga-link" target="_blank" rel="noopener noreferrer">
            {event.liga.Altersklasse} - {event.liga.Name}
          </a>
          { event.shallShowEventSubscription?
            <EventSubscription event={event} />
          : null }
        </div> : null
      }

      <div className="event-header">
        <h4>{event.title}</h4>
        <div className="spiel-ergebnis">
          { event.category !== "other" ?
            <SpielErgebnis event={event} />
          : null
          }
        </div>
      </div>

      <div className="event-info">
        <div>
          <FiClock /> {formatDateForEventItem(event.start)} Uhr &nbsp;
        </div>
        {event.location && (
          <div>
            {event.category === "other" ? <FiMapPin /> : event.category === "home" ? <FaHome /> : <FaCarSide />} &nbsp;
            <a
              href={getGoogleMapsLink(event.location)}
              target="_blank"
              rel="noopener noreferrer"
              title={event.location_full}
            >
              {event.location}
            </a>
          </div>
        )}
      </div>

      {event.category === "other" ? 
        <EventDescription text={event.description ? event.description : ''} />
      : null}
    </div>
  );
};


export default EventItem;